import { EditOutlined, LoadingOutlined } from '@ant-design/icons';
import { Button, Empty, Spin, Tooltip } from 'antd';
import Header from 'components/header';
import PageWrapper from 'components/pageWrapper';
import ReviewStatusIcon from 'components/reviewStatusIcon';
import dayjs from 'dayjs';
import pluralize from 'pluralize';
import { useEffect, useState } from 'react';
import { listMyCycles } from 'services/api/my/cycles';
import styles from 'styles/components/myCycles.module.scss';
import { CYCLE_STATUS, MODULES_ITEMS, REVIEW_STATUS } from 'utils/constants';

const CycleItem = ({ cycle }) => {
  const hasNoTaskOrAllDone = cycle.tasks.every(
    (task) => task.status === REVIEW_STATUS.DONE
  );
  return (
    <div key={cycle._id} className={styles.cycle}>
      <div className={styles.cycleLeft}>
        <div className={styles.cycleName}>
          <a href={`/#/my/cycles/${cycle._id}`} className={styles.cycleLink}>
            <h2>{cycle.name}</h2>
          </a>
        </div>

        <div className={styles.reviewsStatus}>
          {cycle.tasks.map((task, index) => (
            <div className={styles.reviewItem} key={task.type + index}>
              <div>
                <ReviewStatusIcon status={task.status} />
              </div>
              <div>
                {MODULES_ITEMS[task.type].labelShort}
                {task.type === MODULES_ITEMS.PEER.type
                  ? ` (${task.user.profile.firstName})`
                  : ''}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.cycleRight}>
        <div
          className={styles.cycleDeadline}
          style={{
            color:
              dayjs(cycle.deadline).diff(dayjs(), 'day') <= 3
                ? 'red'
                : '#389e0d',
          }}
        >
          <Tooltip
            title={
              <div>
                Deadline: {dayjs(cycle.deadline).format('YYYY-MM-DD HH:mm')}
              </div>
            }
          >
            {dayjs(cycle.deadline).isBefore(dayjs()) ? (
              <span style={{ color: 'black' }}>Cycle ended</span>
            ) : (
              <>
                {dayjs(cycle.deadline).diff(dayjs(), 'day') > 0
                  ? `${dayjs(cycle.deadline).diff(dayjs(), 'day')} ${pluralize(
                      'day',
                      dayjs(cycle.deadline).diff(dayjs(), 'day')
                    )}
              remaining`
                  : 'Last day to respond'}{' '}
              </>
            )}
          </Tooltip>
        </div>
        <div>
          <a href={`/#/my/cycles/${cycle._id}`}>
            <Button type="primary" icon={<EditOutlined />}>
              {hasNoTaskOrAllDone ? 'View review' : 'Fill my part'}
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};

const MyCycles = () => {
  const [cycles, setCycles] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    listMyCycles()
      .then((res) => {
        setCycles(res.data);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const doneCycles = cycles?.filter(
    (cycle) =>
      !cycle.isArchived &&
      cycle.status !== CYCLE_STATUS.DRAFT &&
      dayjs(cycle.deadline) < dayjs()
  );

  const allCycles = cycles?.filter(
    (cycle) => !doneCycles.find((doneCycle) => doneCycle._id === cycle._id)
  );

  return (
    <div>
      <Header />
      <PageWrapper width={1080}>
        <div className={styles.content}>
          <div className={styles.inner}>
            <div className={styles.header}>
              {/* <Breadcrumb
                items={[
                  {
                    title: (
                      <a href="/#/dashboard">
                        <HomeOutlined />
                        &nbsp;Dashboard
                      </a>
                    ),
                  },
                ]}
              /> */}
              <div className={styles.headerContent}>
                <div className={styles.headerTitle}>
                  <h1>My Cycles</h1>
                </div>
              </div>
            </div>
            {loading && (
              <div
                style={{
                  textAlign: 'center',
                  marginTop: 24,
                  marginBottom: 24,
                }}
              >
                <Spin
                  spinning={loading}
                  indicator={<LoadingOutlined spin style={{ fontSize: 44 }} />}
                />
              </div>
            )}
            <div className={styles.cycles}>
              {allCycles &&
                allCycles?.map((cycle) => {
                  return <CycleItem key={cycle._id} cycle={cycle} />;
                })}
              {doneCycles && doneCycles.length > 0 && (
                <div style={{ marginTop: 24 }}>
                  <h2>Done cycles</h2>
                  {doneCycles?.map((cycle) => {
                    return <CycleItem key={cycle._id} cycle={cycle} />;
                  })}
                </div>
              )}
              {(!cycles || cycles.length === 0) && !loading && (
                <div>
                  <Empty
                    description="No cycles found, reach out to your manager or an admin if you think this is an error."
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </PageWrapper>
    </div>
  );
};

export default MyCycles;
